
document.addEventListener('DOMContentLoaded', function () {
  var clubLinks = document.querySelectorAll('a[href="https://club.venezianico.com/"]');
  clubLinks.forEach(link => {
    link.addEventListener('click', function (event) {
      Shopify.analytics.publish('s4w_event', {
        'event': 'join_the_club',
      });
      // event.preventDefault();
    });
  });


});